module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popin popin-infos"
  }, [_c('div', {
    class: 'popin-container'
  }, [_c('div', {
    staticClass: "popin-close",
    on: {
      "click": _vm.closePopin
    }
  }), _vm._v(" "), (_vm.params.typeInfos === 'character') ? [_c('img', {
    attrs: {
      "src": _vm.params.img,
      "alt": _vm.params.name
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "popin-infos__name"
  }, [_vm._v(_vm._s(_vm.params.name))]), _vm._v(" "), _c('p', {
    staticClass: "popin-infos__description",
    domProps: {
      "innerHTML": _vm._s(_vm.params.descr)
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "popin-infos__btn btn",
    on: {
      "click": _vm.closePopin
    }
  }, [_vm._v("\n        Fermer\n      ")])] : _vm._e(), _vm._v(" "), (_vm.params.typeInfos === 'person') ? [_c('img', {
    attrs: {
      "src": ("http://transfertsdepekin.fr/assets/questions/" + (_vm.params.characterImg)),
      "alt": _vm.params.character
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "popin-infos__name"
  }, [_vm._v(_vm._s(_vm.params.character))]), _vm._v(" "), _c('p', {
    staticClass: "popin-infos__description",
    domProps: {
      "innerHTML": _vm._s(_vm.params.bio)
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "popin-infos__btn btn",
    on: {
      "click": _vm.closePopin
    }
  }, [_vm._v("\n        Fermer\n      ")])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90f7b1b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PopinInfos.vue
// module id = 92
// module chunks = 0